import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, captureSource, EVENT } from "@/lib/track";

// Mounted once: captures traffic source + logs a pageview on every route change
export const Tracker = () => {
  const location = useLocation();
  useEffect(() => { captureSource(); }, []);
  useEffect(() => {
    track(EVENT.PAGEVIEW, location.pathname);
  }, [location.pathname]);
  return null;
};
